import script from "./VBreadcrumbsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VBreadcrumbsItem.vue?vue&type=script&setup=true&lang=js"

import "./VBreadcrumbsItem.vue?vue&type=style&index=0&id=76580471&scoped=true&lang=scss"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76580471"]])

export default __exports__